import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type DividerProps = {
	color?: string;
	mobileHide?: boolean;
}

const Divider: FC<DividerProps> = ({color = '#B3E5C2', mobileHide = false}) => { // salad80
	return (
		<div className={classNames({
			[styles.rectangle]: true,
			[styles.mobileHide]: mobileHide,
		})} style={{backgroundColor: color}} />
	);
};

export default Divider;
